export const CONSIDERATION_LEVEL_GREEN = 'green';
export const CONSIDERATION_LEVEL_YELLOW = 'yellow';
export const CONSIDERATION_LEVEL_RED = 'red';
